module.exports = __webpack_public_path__ + "static/full4-089af4d2319bb27cd21c9c904f125f3e.png";